import { memo } from 'react'
import { Handle, Position, NodeProps, useReactFlow } from 'reactflow'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { TaskNodeContainer, TaskNodeTitle, TaskNodeDelete } from '../Workflows.styled'
import { TaskNodeData } from './workflowGraph'

export const TaskNode = memo(({ id, data, selected }: NodeProps<TaskNodeData & { isRoot?: boolean }>) => {
  const { setNodes, setEdges } = useReactFlow()

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation()
    setNodes((prev) => prev.filter((n) => n.id !== id))
    setEdges((prev) => prev.filter((e) => e.source !== id && e.target !== id))
  }

  return (
    <TaskNodeContainer root={data.isRoot} selected={selected}>
      <Handle type='target' position={Position.Left} />
      <TaskNodeTitle>{data.name}</TaskNodeTitle>
      <TaskNodeDelete onClick={handleDelete} title='Remove task'>
        <CloseIcon />
      </TaskNodeDelete>
      <Handle type='source' position={Position.Right} />
    </TaskNodeContainer>
  )
})

TaskNode.displayName = 'TaskNode'
